<template>
  <div class="container my-1 font-be-vietnam">
    <div class="divSearch">
      <b-form id="frmSearch">
        <div class="filter">

          <div class="row">
            <div class="col-12 col-md-12">
              <h3>Bộ lọc <span class="reset" @click="resetFormData">Đặt lại</span></h3>
            </div>
            <div class="col-12 col-md-12">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder">Tiêu đề</label>
                </template>
                <b-input-group>
                  <vue-simple-suggest ref="suggest" v-model="localSearchQuery" display-attribute="title"
                    value-attribute="title" :list="fetchSuggesst" :max-suggestions="10" :min-length="3" :debounce="200"
                    @select="onSuggestSelect">
                    <input type="text" @keydown="onResearch($event)">
                    <div slot="suggestion-item" slot-scope="scope">
                      <span v-html="boldenSuggestion(scope)"></span>
                    </div>

                  </vue-simple-suggest>
                  <b-input-group-append>
                    <b-button variant="primary" @click="updateSearchQuery">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <!-- <div class="col-12 col-md-12">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder">Tiêu đề</label>
                </template>
                <b-input-group>

                  <b-form-input v-model="localSearchQuery" class="d-inline-block" placeholder="Tiêu đề"
                    @keyup.enter="updateSearchQuery" />
                  <b-input-group-append>
                    <b-button variant="primary" @click="updateSearchQuery">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div> -->
          </div>
          <div class="row">
            <div class="col-12 col-md-3">
              <b-form-group label="Thể loại">
                <template #label>
                  <label class="d-block font-weight-bolder">Thể loại</label>
                </template>
                <v-select v-model="article_type_id" :options="ArticleType" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Chuyên mục">
                <template #label>
                  <label class="d-block font-weight-bolder">Chuyên mục</label>
                </template>
                <v-select v-model="category_id" :options="all_cats" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Đơn vị lấy tin">
                <template #label>
                  <label class="d-block font-weight-bolder">Đơn vị lấy tin</label>
                </template>
                <v-select v-model="department_news" :options="dataDepartment" label="name" :reduce="(val) => val.code"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Ngày đăng">
                <template #label>
                  <label class="d-block font-weight-bolder">Ngày đăng</label>
                </template>
                <date-picker v-model="loadDateRange" type="datetime" range ref="datetime" :shortcuts="shortcuts"
                  :show-time-panel="false" format='DD/MM/YYYY' valueType="format"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"></date-picker>

              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-3">
              <b-form-group label="Đơn vị">
                <template #label>
                  <label class="d-block font-weight-bolder">Đơn vị</label>
                </template>
                <v-select v-model="department_unit" :options="dataDepartment" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" @option:selecting="selectedOption" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Phòng ban">
                <template #label>
                  <label class="d-block font-weight-bolder">Phòng ban</label>
                </template>
                <v-select v-model="department_id" :options="dataPhongBan ? dataPhongBan : []" label="name"
                  :reduce="(val) => val.id" placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Tác giả (Bút danh)">
                <template #label>
                  <label class="d-block font-weight-bolder">Tác giả (Bút danh)</label>
                </template>
                <b-form-input v-model="loadQueryAlias" placeholder="Tác giả" @keyup.enter="updateSearchQuery" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Lấy tin">
                <template #label>
                  <label class="d-block font-weight-bolder">Lấy tin</label>
                </template>
                <v-select v-model="article_get_id" :options="dataGet" label="name" :reduce="(val) => val.id"
                  placeholder="--Tất cả--" />
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="show_search">
          <div class="total d-none d-sm-block">
            <h3>Danh sách</h3>
            <p class="mb-0 text-muted font-weight-bolder" v-if="itemsData.length > 0"> Hiển thị {{ dataMeta.from }} đến {{
              dataMeta.to }} tin trên {{ dataMeta.of }} tin </p>
          </div>
          <div class="show_option">
            <ul>
              <li class="sort">
                <span class="d-none d-sm-block">Sắp xếp theo: </span>
                <span>
                  <b-form-select v-model="sort_id" :options="dataSort" place-holder="--Chọn--" />
                </span>
              </li>
              <!-- <li>
                <b-button v-b-tooltip.hover
                  variant="flat-success"
                  class="btn-icon active"
                  title="Dạng danh sách">
                  <feather-icon size="20"
                    icon="ListIcon" /></b-button>
              </li>
              <li>
                <b-button v-b-tooltip.hover
                  variant="flat-success"
                  class="btn-icon"
                  title="Dạng lưới">
                  <feather-icon size="20"
                    icon="GridIcon" /></b-button>
              </li> -->
              <li>
                <b-button v-b-tooltip.hover variant="whites" :disabled="loading" class="excel"
                  @click="exportExcel($event)"> <feather-icon icon="DownloadIcon" />&nbsp;&nbsp; Excel </b-button>
              </li>
              <li>
                <b-button variant="blue" class="text-white pl-1 pr-1" @click="resetFormData">
                  <feather-icon icon="RepeatIcon" /> Làm mới</b-button>
              </li>
            </ul>
          </div>
        </div>
        <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
          <div class="mt-1 post_list">
            <div v-if="itemsData.length > 0">
              <ul class="listview">
                <li v-for="(item, index) in itemsData " :key="index" class="post_view ">
                  <div class="item row d-flex">
                    <div class="col-12 col-md-8">
                      <div class="d-flex flex-row item-info">
                        <div class="datetime">
                          <span class="font-size14-be-vietnam time">{{
                            moment.unix(item._source.published_at).format('DD/MM/YYYY, HH:mm:ss') }}</span>
                          <span class="font-size14-be-vietnam category-name">{{ item._source.category.name }}</span>
                        </div>
                        <div class="thumb">
                          <router-link
                            :to="{ name: 'home-view', params: { id: item._source.id, slug: item._source.slug } }"
                            class="link" :title="item._source.title">
                            <img :src="item._source.image">
                          </router-link>
                        </div>
                        <div class="titles">
                          <router-link
                            :to="{ name: 'home-view', params: { id: item._source.id, slug: item._source.slug } }"
                            class="link" :class="item.css_link" :title="item._source.title">
                            <span v-html="getTitle(item)"></span>
                            <span v-if="item.hot" class="iconHotGif" /> <span v-if="item.is_get" class="iconNewsRead" />
                          </router-link>
                          <div class="icons">
                            <span v-for="( val, index ) in item._source.content_type " :key="index"
                              :class="`icon` + val" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 pl-1">
                      <div class="d-flex flex-column item-unit">
                        <div class="pseudonym">
                          <label class="w-25">Tác giả:</label>
                          <div class="unit-code"> {{ item._source.author ? item._source.author.department_unit.code : ''
                          }} <span>{{ item._source.author ? '(' + (item._source.author.alias ? item._source.author.alias
  : item._source.author.username) + ')' : '' }}</span>
                          </div>
                        </div>
                        <div class="unit-list">
                          <label class="w-25">Ban lấy tin:</label>
                          <div v-if="item._source.department_unit" class="list w-75">
                            <div v-for="(item, i ) in (item._source.department_unit)" :key="i" class="info">
                              <label>{{ item.name }} ({{ item.childs.length }})</label>
                              <div class="depart card">
                                <div class="card-body p-0">
                                  <span v-for="(child, index) in item.childs" :key="index">{{ child.department_code
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <b-row class="mt-2 mb-1">
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                  <span class="text-muted">{{ $t('show_to_entries', {
                    from: dataMeta.from, to: dataMeta.to, of:
                      dataMeta.of
                  }) }}</span>
                </b-col>
                <!-- Pagination -->
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                  <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                    class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <p class="text-center"> Không tìm thấy bản ghi nào </p>
            </div>
          </div>
        </b-overlay>
      </b-form>
    </div>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BTable,
  BPagination,
  BImg,
  BFormInput,
  BFormGroup,
  VBTooltip,
  BFormSelect,
  BLink,
  BForm,
  BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue';
import {
  ref, watch, computed, onMounted
} from '@vue/composition-api';
import store from '@/store'
import vSelect from 'vue-select'
import { showToast, useRouter } from '@/@core/utils/utils';
import moment from 'moment';
import Ripple from 'vue-ripple-directive';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
export default {
  components: {
    BCard,
    BOverlay,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BLink,
    BTable,
    BPagination,
    BImg,
    BFormInput,
    BFormSelect,
    BFormGroup,
    vSelect,
    BForm,
    BInputGroupAppend,
    BInputGroup,
    DatePicker,
    VueSimpleSuggest
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      dataParent: [],
      moment,
      disabled: false,
      loadDateRange: '',
      dataSuggest: [],
      chosen: ''
    }
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    }
  },
  setup(props, ctx) {
    const { route, router } = useRouter();
    const loading = ref(true)
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const searchQuery = ref('')
    const localSearchQuery = ref('')
    const loadQueryAlias = ref('')
    const itemsData = ref([]);
    const department_id = ref('')
    const department_news = ref('')
    const department_unit = ref('')
    const start_date = ref('');
    const end_date = ref('');
    const refListTable = ref(null)
    const ArticleType = ref([])
    const all_cats = ref([])
    const article_type_id = ref('')
    const category_id = ref('')
    const alias = ref('')
    const dataDepartment = ref([])
    const dataPhongBan = ref([])
    const unit_get_id = ref('')
    const article_get_id = ref('')
    const sort_id = ref(1)
    const date_range = ref('')
    const now = new Date();
    const iddaterange = ref(null)


    const shortcuts = ref([
      { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
      { text: 'Hôm qua', onClick: () => [new Date(Date.now() - 3600 * 1000 * 24), new Date()] },
      { text: 'Tuần trước', onClick: () => [new Date(Date.now() - 7 * 24 * 3600 * 1000), new Date()] },
      { text: 'Tháng hiện tại', onClick: () => [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0)] },
      { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
      { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] }
    ])

    const dataSort = ref([
      { value: 1, text: 'Ngày đăng' },
      { value: 2, text: 'Tiêu đề' },
    ])
    const dataGet = ref([
      { id: 1, name: 'Tin đã sử dụng' },
      { id: 2, name: 'Tin chưa sử dụng' },
    ])
    const fetchAll = () => {
      store.dispatch('home/searchElastic', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        department_id: department_id.value,
        start_date: start_date.value,
        end_date: end_date.value,
        article_type_id: article_type_id.value,
        category_id: category_id.value,
        department_id: department_id.value,
        unit_get_id: unit_get_id.value,
        article_get_id: article_get_id.value,
        alias: alias.value,
        sort_id: sort_id.value,
        department_news: department_news.value,
        department_unit: department_unit.value,
      })
        .then(response => {
          loading.value = false
          const result = response.data;

          if (result.code === 200) {
            itemsData.value = result.data.data
            total.value = result.data.total;
            if (result.data.config.all_cats.length > 0) {
              all_cats.value = result.data.config.all_cats;
            }

            dataPhongBan.value = (result.data.config.data_phongban.length > 0) ? result.data.config.data_phongban : []

            if (result.data.config.department.length > 0) {
              dataDepartment.value = result.data.config.department
            }
            if (result.data.config.articleType.length > 0) {
              ArticleType.value = result.data.config.articleType;
            }
          }
        })
    }

    const dataMeta = computed(() => {
      const localItemsCount = 30
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    fetchAll()
    watch([currentPage], () => {
      if (!loading.value) {
        refetchData();
      }
    });
    watch([perPage, searchQuery, alias, article_type_id, department_news, department_unit, department_id, start_date, end_date, category_id, article_get_id, sort_id], () => {
      currentPage.value = 1
      if (!loading.value) {
        refetchData();
      }
    });

    const refetchData = () => {
      loading.value = true;
      fetchAll();
    };

    const updateSearchQuery = () => {
      alias.value = loadQueryAlias.value
      searchQuery.value = localSearchQuery.value

    }
    const onSuggestSelect = (suggest) => {
      searchQuery.value = suggest.title
    }
    const clearDate = () => {
      start_date.value = ''
      end_date.value = ''
    }

    onMounted(() => {
      window.addEventListener('scroll', () => {
        const curr = window.pageYOffset;

        if (window.scrollY <= 20) {
          if (document.querySelector('#headerBanerCategory')) {
            document.querySelector('#headerBanerCategory').classList.remove('fixBanner');
          }
        } else if (window.scrollY > 20 || route.value.name !== 'home') {
          if (document.querySelector('#headerBanerCategory')) {
            document.querySelector('#headerBanerCategory').classList.add('fixBanner');
          }
        }
      });
    });
    const fetchSuggesst = (keyword) => {
      return store.dispatch('home/fechDataSuggest', {
        q: keyword
      }).then(response => {
        return response.data.data
      })
    }

    const onResearch = (event) => {

      if (event.keyCode == 13) {
        searchQuery.value = event.target.value
      }
    }
    const refreshData = () => {
      currentPage.value = 1
      loadDateRange.value = '';
      localSearchQuery.value = '';
      searchQuery.value = '';
      start_date.value = '';
      end_date.value = '';
      article_type_id.value = '';
      category_id.value = '';
      department_id.value = '';
      unit_get_id.value = ''
      article_get_id.value = ''
      alias.value = ''
      sort_id.value = ''
      department_news.value = ''
      department_unit.value = ''
      fetchAll();
    }


    return {
      dataMeta,
      itemsData,
      currentPage,
      refListTable,
      perPage,
      loading,
      total,
      ArticleType,
      all_cats,
      article_type_id,
      article_get_id,
      searchQuery,
      category_id,
      start_date,
      end_date,
      alias,
      dataDepartment,
      department_id,
      refetchData,
      dataGet,
      updateSearchQuery,
      localSearchQuery,
      loadQueryAlias,
      dataSort,
      sort_id,
      date_range,
      department_news,
      department_unit,
      dataPhongBan,
      clearDate,
      shortcuts,
      iddaterange,
      fetchSuggesst,
      onResearch,
      onSuggestSelect,
      refreshData
    }
  },
  methods: {
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggest.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|\.]/gm).filter(t => !!t) || [''];
      return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
    },
    getTitle(item) {

      let title = item._source.title
      if (item.highlight && item.highlight.title) {
        title = item.highlight.title[0]
      }
      return item._source.article_type.code + ' - ' + title
    },
    resetFormData() {
      this.loadQueryAlias = ''
      this.alias = ''
      this.searchQuery = ''
      this.localSearchQuery = ''
      this.date_range = ''
      this.start_date = ''
      this.end_date = ''
      this.article_type_id = ''
      this.department_news = ''
      this.department_unit = ''
      this.department_id = ''
      this.category_id = ''
      this.currentPage = 1
      this.sort_id = ''
      this.article_get_id = ''
      this.loadDateRange = ''

    },
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
    },
    selectedOption(val) {
      this.department_id = ''
    },
    exportExcel() {

      if (!this.start_date && !this.end_date) {
        showToast('Phải chọn khoảng thời gian cần xuất bản')
        return false;
      } else {
        this.loading = true;
        this.disabled = true;
        store.dispatch('home/exportElastic', {
          keyword: this.searchQuery,
          department_id: this.department_id,
          start_date: this.start_date,
          end_date: this.end_date,
          article_type_id: this.article_type_id,
          category_id: this.category_id,
          department_id: this.department_id,
          unit_get_id: this.unit_get_id,
          article_get_id: this.article_get_id,
          alias: this.alias,
          sort_id: this.sort_id,
          department_news: this.department_news,
          department_unit: this.department_unit,
          total: this.total

        }).then(response => {
          this.loading = false;
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            let text_date = moment().format('YYYY-MM-DD.HH.mm')
            let fileName = 'Thống kê số lượng tin bài ' + text_date + '.xlsx';
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            this.disableBtn = false
            showToast('Tải file thành công', { variant: 'success' });
          } else {
            showToast('Lỗi tải file')
            this.disableBtn = false
          }

        })
      }
    },
    onReset() {
      this.localSearchQuery = ''
      this.loadQueryAlias = ''
      this.category_id = ''
      this.department_id = ''
      this.searchQuery = ''
      this.department_news = ''
      this.department_unit = ''
      this.start_date = ''
      this.end_date = ''
      this.article_get_id = ''
      this.sort_id = ''
      this.alias = ''
      this.date_range = ''
      this.article_type_id = ''

      this.refetchData()
    },
    switchMode(mode) {
      if (mode === 'list') {
        this.showMode = 'list'
      } else {
        this.showMode = 'grid'
      }
      return this.showMode
    },

  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';


.class_title_detail_normall,
.class_title_detail_nohot_notget_notview {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 22px;
  /* Dark/1-Dark */
  color: #202020 !important;

}

.class_title_detail_hot_get_view {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 22px;
  color: #993300 !important;
}

.class_title_detail_hot_get_notview {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 22px;
  color: #993300 !important;
}

.class_title_detail_hot_notget_view,
.class_title_detail_nohot_notget_view {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 22px;
  color: #84818A !important;
}

.vue-simple-suggest {
  width: calc(100% - 58px);

  .input-wrapper input {
    padding: 0.6rem 1rem !important;
    border-color: #d8d6de !important;
    border-top-left-radius: 0.357rem !important;
    border-bottom-left-radius: 0.357rem !important;
  }

}

.class_title_detail_hot_notget_notview {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 22px;
  /* Dark/1-Dark */
  color: #202020 !important;
}

.class_title_detail_nothot_get_view,
.class_title_detail_nothot_notget_notview {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 22px;
  color: #993300 !important;
}

.show_list_view svg {
  color: #086BB5;
}

.show_list_view {
  padding-top: 0px !important;
}

.home_post_list {
  .filter {
    width: 100%;
    background: #fff;
    padding: 15px;
    list-style: none;
    border-top-right-radius: 5px;
    border-top-left-radius: 5;

    .row {
      margin: 0 -0.5rem;

      .col-12 {
        padding: 0 0.5rem;
      }

      .end_date {
        div {
          padding-top: 1.9rem;
        }
      }
    }

    .btn {
      padding: 0.786rem 1rem;
      margin-top: 1.9rem;

      &:hover {
        transform: translateY(0px);
      }
    }
  }

  .table {
    tr {
      th {
        font-size: 1rem;
        font-weight: bold;
        color: #84818A;
      }

      td {
        padding: 0.72rem 0.8rem;
        vertical-align: top;
        font-size: 16px;
        font-family: 'Manrope';
        ;

        color: #202020;

        div {
          font-weight: 500;
        }

        a {
          vertical-align: top;
          display: flex;
          color: #0e1f3a;
          font-size: 15px;

          &:hover {
            color: #0763a8;
          }

          .news-icon {
            position: relative;
            top: 3px;

            span {
              margin-right: 5px;
            }
          }
        }
      }
    }

    .post-title {
      img {
        max-width: 110px;
        margin-right: 1rem;
      }
    }
  }
}

.show {
  display: block;
}

.hide {
  display: none !important;
}

.col-5-item {
  width: calc(100% / 5);

  a {
    vertical-align: top;
    color: #0e1f3a;
    font-size: 15px;

    &:hover {
      color: #0763a8 !important;
    }

    .news-icon {
      position: relative;
      top: 3px;

      span {
        margin-right: 5px;
      }
    }
  }
}

.trunc {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.trunc-2 {
  -webkit-line-clamp: 2;
}

.div_thumbnail {
  min-height: 185px;
  width: 100%;
  max-height: 185px;
  height: 185px;
}

.span_title {
  height: 50px;
}

.padding-category {
  padding-top: 0px;
  padding-bottom: 10px
}

@media (max-width: 768px) {
  .col-5-item {
    width: calc(100% / 2);
  }
}

// .div_img {
//   // position: relative;
//   // // height: 100px;
//   // // width: 30%;
//   // width: 20%;

// }

.a_img {
  position: relative;
  display: block;
  padding-top: 60%;
  overflow: hidden;
  background-color: #eee;

}

.div_title {
  // width: 70%;
  // width: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
}

.thumbnail_img {
  // position: absolute;
  // width: 100%;
  // max-height: 100px;
  // object-fit: contain
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: contain;
}

.btn_show_part_read:hover+.span_show_part_read {

  display: flex;

}

.span_show_part_read {
  display: none;
  background: #FFFFFF;

  box-shadow: 1px 1px 16px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.item_part {
  background: #FAF6F6;
  border-radius: 4px;
  padding: 3px 3px;

  position: relative;
}

.item_part_child {
  background: #FAF6F6;
  border-radius: 4px;
  padding: 4px 8px;
}

.item_child {
  display: none;
  background: #ffff;
  border: 1px solid rgb(232, 232, 232);
  border-radius: 6px;
  position: absolute;
  z-index: 9999;
}

.btn_show_part {
  background: rgba(8, 107, 181, 0.05);
  border-radius: 4px;
  color: #086BB5;
}

.parent:hover .item_part {
  color: #086BB5;
}

.parent:hover .item_child {
  display: block;
}

.breadcrumb_category_child {
  padding-bottom: 10px;

  .total {
    font-weight: bold;
    line-height: 30px;
    font-size: 15px;
  }

  .btn {
    padding: 0.3rem 0.6rem !important;
    margin-top: 0 !important;

  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    vertical-align: middle;

    li {
      height: 30px;
      line-height: 35px;
      vertical-align: middle;
      padding: 0 15px;

      &:first-child {
        padding-left: 0;

        a {
          color: #202020;
          text-transform: uppercase;
          font-size: 18px;
          font-weight: 600;

          &::before {
            display: none;
          }
        }
      }

      a {
        font-size: 15px;
        color: #868a9d;
        line-height: 25px;
        position: relative;

        &::before {
          position: absolute;
          left: -15px;
          top: 7px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #868a9d;
          content: '';
          display: block;
        }
      }
    }
  }
}
</style>
